import { css } from 'styled-components';

export const darkFocusRing = css`
  0 0 0 2px ${({ theme }) => theme.palette.white},
  0 0 0 4px ${({ theme }) => theme.palette.darkBackground}
`;

export const focusStyles = css`
  outline: 0;
  box-shadow: ${darkFocusRing};
`;

/* For elements that already have a box-shadow border use this function to return
  the original border styling plus the focus ring around it */
export const getFocusStylesWithBorder = (border = 'none') => css`
  ${focusStyles};
  box-shadow: ${border}, ${darkFocusRing};
`;
